import { createContext, type PropsWithChildren, useContext, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { MembersStore } from 'pages/settings/pages/members/store/membersStore'

export const MembersContext = createContext<MembersStore | null>(null)

export const useMembersContext = () => {
  const context = useContext(MembersContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with MembersContext')

  return context
}

export const MembersProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new MembersStore(entities), [])

  return <MembersContext.Provider value={store}>{children}</MembersContext.Provider>
}
